import '../css/master.scss';
import '../css/index.scss';
import '../css/about.scss';
import '../css/work.scss';
import '../css/contact.scss';
import '../css/w.scss';

import * as helper from './helpers';
import * as scroll from './helpers/scroll';
import * as viewpoint from './helpers/viewpoint';
import * as animations from './helpers/animations';

import * as contact from './contact';
import * as work from './work';
import * as navigation from './navigation';
import barba from '@barba/core';

barba.init({
  timeout: 7e3,
  sync: true,
  // Prevents current page from reload. (Will be changed later to replay transition and actually reload page properly)
  prevent: ({el, href}) => {
    if (href == location.href) {
      helper.preventDefault(el)
    }
  },
  // If the hovered on link is unavailable, it is prevented from load and instead transitions to the 404 page.
  requestError: (trigger, action, url, response) => {
    if (response.status && response.status == 404) {
      if (!trigger.dataset.barbaPrevent) {
        trigger.dataset.barbaPrevent = '';

        helper.preventDefault(trigger, () => {
          barba.go('/404').then(() => {
            trigger.removeAttribute('data-barba-prevent')
          });
        })
      }
    }
  },
  transitions: [{
    /**
     * Hook at leave transition.
     * Also responsible for how long to wait till the page transitions in.
     */
    async leave() {
      const done = this.async();

      animations.transition();
      await new Promise((done) => setTimeout(() => done(), 1000));
      
      done()
    },

    /**
     * Hook after everything has loaded.
     */
    async after(data) {
      initialize(data);
    },

    /**
     * Current page on its first load.
     */
    async once(data) {
      initialize(data, true)
    }
  }]
})

/**
 * Initializes core functions of the page using Barba.js data.
 * Also responsible for updating & controlling media as well as dates within the site.
 * @param {Object} data barba.js provided data of current, next page and the trigger
 * @param {boolean} [once]
 */
function initialize(data, once) {
  navigation.highlightText(data.next.namespace);

  viewpoint.observeMediaContent();
  viewpoint.observeVideoPlayback();
  viewpoint.observeElementAnimation();
  
  work.updateDate();
  scroll.update(once);
  animations.transition(true);

  if (data.next.namespace == 'w') {
    work.updateFooter()
  }

  if (data.next.namespace == 'contact') {
    contact.addContactListeners()
  }
}